import React from 'react'
import { Outlet } from 'react-router-dom'

const AdminAuthFeature = () => {
  return (
    <Outlet />
  )
}

export default AdminAuthFeature